export const base_be_url=process.env.REACT_APP_BASE_BE_URL
export const base_fe_url=process.env.REACT_APP_BASE_FE_URL


